// extracted by mini-css-extract-plugin
export var oneChild = "Issue-module--oneChild--LmsvU";
export var root = "Issue-module--root--OXHy6";
export var row = "Issue-module--row--ZD4ee";